// Shared display formatters for the Skip report KPI tiles (the data tables
// format via reportRunnerUtils.formatCell). en-GB locale, GBP currency.

export function gbp(n: number): string {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(n);
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('en-GB').format(n);
}

export function pct(n: number): string {
  return `${n.toFixed(1)}%`;
}

export function days(n: number): string {
  return `${n.toFixed(1)} d`;
}
